import { FC } from "react";

// Components
import { Box, Skeleton } from "@mui/material";
import Details from "@/components/recipe_builder/recipe_card/details";


const LoadingRecipe: FC = () => {

    return (
        <Box
            width="100%"
            height="100%"
            sx={{
                borderRadius: '6px',
                border: "1px solid var(--border-subtle-01)",
                backgroundColor: 'var(--layer-01)',
                aspectRatio: '1/1'
            }}
            >
            <Skeleton variant="rectangular" width="100%" height="calc(100% / 16 * 9" />
            <Details
                title="Loading..."
                prepTime={0}
                cookTime={0}
                isLoading={true}
            />
        </Box>
        );
}

export default LoadingRecipe;